import {
  getAll,
  getPage,
  getDetail,
  deleteObj,
} from '@/api/custompoiserv'

export default {
  state: {
    state_CustomPOI_GetAllResult: null,
    state_CustomPOI_GetPageResult: null,
    state_CustomPOI_GetDetailResult: null,
    state_CustomPOI_DeleteObjResult: null,
  },
  mutations: {
    SET_CUSTOMPOI_GETALL_RESULT: (state, rst) => {
      state.state_CustomPOI_GetAllResult = rst;
    },
    SET_CUSTOMPOI_GETPAGE_RESULT: (state, rst) => {
      state.state_CustomPOI_GetPageResult = rst;
    },
    SET_CUSTOMPOI_GETDETAIL_RESULT: (state, rst) => {
      state.state_CustomPOI_GetDetailResult = rst;
    },
    SET_CUSTOMPOI_DELETEOBJ_RESULT: (state, rst) => {
      state.state_CustomPOI_DeleteObjResult = rst;
    },
  },
  actions: {
    CustomPOIServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CustomPOIServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CUSTOMPOI_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CUSTOMPOI_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_CustomPOI_GetAllResult: state => {
      return state.state_CustomPOI_GetAllResult;
    },
    get_CustomPOI_GetPageResult: state => {
      return state.state_CustomPOI_GetPageResult;
    },
    get_CustomPOI_GetDetailResult: state => {
      return state.state_CustomPOI_GetDetailResult;
    },
    get_CustomPOI_DeleteObjResult: state => {
      return state.state_CustomPOI_DeleteObjResult;
    },
  }
}